module.exports = __webpack_public_path__ + "img/scroll-old.24960bb7.svg";